class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupHoverOpen();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  setupHoverOpen() {
    const DELAY = 80;
    let openTimer = null;
    let closeTimer = null;
    const mq = window.matchMedia('(min-width: 990px)');

    const open = () => {
      clearTimeout(closeTimer);
      if (this.mainDetailsToggle.hasAttribute('open')) return;
      openTimer = setTimeout(() => {
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      }, DELAY);
    };

    const close = () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }, DELAY);
    };

    this.addEventListener('mouseenter', () => { if (mq.matches) open(); });
    this.addEventListener('mouseleave', () => { if (mq.matches) close(); });
  }
}

customElements.define('header-menu', HeaderMenu);
